module.exports = __webpack_public_path__ + "img/dragonPlaybead.50dd5361.gif";